import { render, staticRenderFns } from "./ChainCreateModal.vue?vue&type=template&id=21d1599f"
import script from "./ChainCreateModal.vue?vue&type=script&lang=ts"
export * from "./ChainCreateModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports